var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Expand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 3 L 3 9 L 5.2929688 6.7070312 L 8.8925781 10.306641 L 10.306641 8.8925781 L 6.7070312 5.2929688 L 9 3 L 3 3 z M 15 3 L 17.292969 5.2929688 L 13.693359 8.8925781 L 15.107422 10.306641 L 18.707031 6.7070312 L 21 9 L 21 3 L 15 3 z M 8.8925781 13.693359 L 5.2929688 17.292969 L 3 15 L 3 21 L 9 21 L 6.7070312 18.707031 L 10.306641 15.107422 L 8.8925781 13.693359 z M 15.107422 13.693359 L 13.693359 15.107422 L 17.292969 18.707031 L 15 21 L 21 21 L 21 15 L 18.707031 17.292969 L 15.107422 13.693359 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Expand);
export default __webpack_public_path__ + "static/media/icons8-expand.c618dfe0.svg";
export { ForwardRef as ReactComponent };